<template>
  <el-table :data="tableData" stripe style="width: 100%;" height="300px">
    <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip
    >
      <template v-if="col.prop === 'DTCreatedDate'" #default="scope">
        {{ formatDate(scope.row.DTCreatedDate) }}
      </template>
    </el-table-column>
    <!-- 具名插槽：操作列 -->
    <el-table-column label="操作"  fixed="right">
      <template #default="scope">
        <slot name="actions" :row="scope.row"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: Array
  },
  data() {
    return {
      columns: [
        { prop: "StrCallNumber", label: "种次号"},
        { prop: "StrPositiveTitle", label: "正题名",width: "200" },
        { prop: "StrBookBarcode", label: "条码号"},
        { prop: "StrISBN", label: "ISBN",width: "170" },
        { prop: "StrFirstResponsible", label: "第一责任者"},
        { prop: "StrOtherResponsible", label: "其他责任者"},
        { prop: "StrSubtitle", label: "副题目"},
        { prop: "StrSeriesTitle", label: "丛书题名"},
        { prop: "StrTypeName", label: "分类号"},
        { prop: "IntNumberCopies", label: "每套册数"},
        { prop: "IntBorrowedCount", label: "借阅次数"},
        { prop: "FloatPricePer", label: "定价"},
        { prop: "StrBinding", label: "装订"},
        { prop: "StrNumberPages", label: "页卷数"},
        { prop: "StrPublicationDate", label: "出版日期"},
        { prop: "StrPublisher", label: "出版社"},
        { prop: "StrPublisherPlace", label: "出版地"},
        { prop: "StrLotNumber", label: "批号"},
        { prop: "StrLibraryName", label: "书屋位置"},
        { prop: "StrBookshelfName", label: "书架"},
        { prop: "DTCreatedDate", label: "录入日期"}
      ]
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  }
};
</script>

<style scoped>

</style>